<template>
  <div>
    <el-select
      v-model="executiveSSelected"
      placeholder="Seleccione el tipo de ejecutivo"
      size="mini"
      @change="OnExecutiveSelected"
    >
      <el-option
        v-for="item in executiveOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ClientRabbeyExecutiveSelector",

  data() {
    return {
      executiveOptions: [
        { value: "vendor", label: "Vendedor" },
        { value: "customerservice", label: "Servicio al Cliente" },
        { value: "accountingmanager", label: "Cuenta por Cobrar" }
      ],
      executiveSSelected: "accountingmanager"
    };
  },

  mounted() {},

  methods: {
    OnExecutiveSelected(excecutiveType) {
      this.$emit("OnExecutiveSelected", excecutiveType);
    }
  }
};
</script>

<style scoped></style>
